<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols" :columns="cols"
        :showfooter="false" :showPage="true" :resizable="true"
        :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject" @pagechange="pagechange"
        :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick">
        <template v-slot:default>
        </template>
      <template slot="btn">
          <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
      </template>
    </vggrid>
    <el-dialog
        title="附件下载（点击文件下载）"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div v-if="appendList.length" class="filelist">
          <div v-for="(item,index) in appendList" :key="index" class="fileitem">
            <div class="name" @click="downFile(item.appendurl)">
              <a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
            </div>
          </div>
        </div>
        <div v-else>无附件</div>
    </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'
  import utils from '../../assets/js/utils'
  import dayjs from 'dayjs'
  export default {
    name: 'psuIndex',
    data () {
      return {
        menuid: this.$route.query.menuid || this.$route.params.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'',width: 80},
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false,width: 150},
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'comfullname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
          // { field: 'dailiname', fieldtype: 'C', title: '代理人',calculExpr:'',addNewRowFlg: false},
          { field: 'psuuserneme', fieldtype: 'C', title: '经办人',calculExpr:'',addNewRowFlg: false, width: 70},
          // { field: 'prsbjbegtime', fieldtype: 'C', title: '报名单位',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'psustatusname', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false, width: 70,
            slots: {
              default: ({row}) => {
                if (+row.prsbmneedconfirm === 1 && +row.psustatus === 1 && row.psuAppendCount === 0 && dayjs(row.prsbmendtime).isBefore(dayjs())) {
                  return [<span>无效</span>]
                } else {
                  if (+row.psustatus === 1) {
                    return [<span>待审</span>]
                  } else if (+row.psustatus === 2) {
                    return [<span>驳回</span>]
                  } else if (+row.psustatus === 3) {
                    return [<span>通过</span>]
                  } else if (+row.psustatus === 4) {
                    return [<span>拒绝</span>]
                  }
                }
              }
            }
          },
          { field: 'psubmamt', fieldtype: 'C', title: '报名费（元）',calculExpr:'',addNewRowFlg: false, width: 120},
          { field: 'psubzjamt', fieldtype: 'C', title: '保证金（元）',calculExpr:'',addNewRowFlg: false, width: 120},
          { field: 'psutypeCN', fieldtype: 'C', title: '报名方式',calculExpr:'',addNewRowFlg: false, width: 80},
          { title: '附件下载 ', width: 160, showOverflow: true,width:108,
            slots: {
              default: ({row}) => {
                  let name = ''
                  if(+row.prsflg===1 || +row.prsflg === 3){
                      name = '竞价文件'
                  } else if(+row.prsflg===4 || +row.prsflg === 5){
                      name = '竞拍文件'
                  } else if(+row.prsflg===6){
                      name = '比选文件'
                  }
                  return [<vxe-button type='primary' onClick={this.showdownFild.bind(this, row)}>{name}</vxe-button>]
              }
            }
          },
          { title: '操作 ', width: 160, showOverflow: true,
            slots: {
              default: ({row}) => {
                  if(+row.psutype === 2 && +row.psustatus === 1){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>确认邀请</vxe-button>]
                  }
                  if(+row.psutype === 2 && +row.psustatus === 2){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>审核已驳回</vxe-button>]
                  }
                  if(+row.projectisinvite === 1 && +row.psustatus === 4){
                    return ['已拒绝邀请']
                  }
                  if(+row.psustatus === 1){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>上传报名文件</vxe-button>]
                  }
                  if(+row.psustatus === 2){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>重新提交</vxe-button>]
                  }
                  if(+row.psustatus === 4){
                    return ['已拒绝']
                  }
                  if(+row.psubmpayuserid && +row.psubmpayflg === 2 && +row.psustatus === 3){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>重新提交报名费</vxe-button>]
                  }
                  if(+row.psubzjpayuserid && +row.psubzjpayflg === 2 && +row.psustatus === 3){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>重新提交保证金</vxe-button>]
                  }
                  if(+row.psubmpaytype === 0 && +row.psustatus === 3 && +row.projectbmamt > 0){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>缴费</vxe-button>]
                  }
                  if(+row.psubzjpaytype === 0 && +row.psustatus === 3 && +row.projectbzjamt > 0){
                    return [<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>缴费</vxe-button>]
                  }
                  else{
                    return[<vxe-button type='primary' onClick={this.goPsuFrom.bind(this, row)}>查看</vxe-button>]
                  }
              }}
          }
        ],
        psu: {},
        query: {
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0
        },
        dialogVisible: false,
        appendList:[]
      }
    },
    created () {
      this.$on('FEEPAY', () => this.feePay())
      this.$on('BZJPAY', () => this.bzjPay())
      this.$on('BMXX',()=>this.bmxx())
      this.$on('UPLOADFILE', () => this.uploadFile())
      this.$on('PBRLIST', () => this.pbrList())
      this.$on('CLOSE', () => this.close())
    },
    async activated() {
      await this.getPageList()
    },
    mounted () {
      this.init()
    },
    mixins: [common],
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      },
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.psu = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0
        }
        this.list = []
        this.btnLoading = false
        this.psu = {}
        this.menuid = this.$route.query.menuid || this.$route.params.menuid
      },
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'psuForm', params: {form: this.project, type: 1, activeName: 'bmxx'}})
      },
      goPsuFrom(row){
        this.project = row
        this.$router.push({name: 'psuForm', params: {form: this.project,innerbtn: this.btn.inner, type: 1}})
      },
      uploadFile () {
        if (!this.psu.psuid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        if (+this.psu.psustatus === 2) {
          this.$message.warning('报名信息已审核，不能上传附件!')
          return
        }
        if (+this.project.projectstatus > 20) {
          this.$message.warning(`项目已进入${this.project.projectstatusname}，无需支付!`)
          return
        }
        this.$router.push({name: 'psuBmUploadFileForm', params: {form: this.psu, type: 1}})
      },
      async feePay () {
        if (!this.psu.psuid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        if (+this.psu.psustatus !== 2) {
          this.$message.warning('暂不允许')
          return
        }
        this.$router.push({name: 'psuBmPayForm', params: {form: this.psu, type: 1}})
      },
      async bzjPay () {
        if (!this.psu.psuid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        if (+this.psu.psustatus !== 2 && +this.psu.psustatus !== 2) {
          this.$message.warning('暂不允许')
          return
        }
        // // if (+this.psu.psustatus === 2) {
        // //   this.$message.warning('报名信息已审核，无需支付!')
        // //   return
        // // }
        // if (+this.project.projectstatus > 20) {
        //   this.$message.warning(`项目已进入${this.project.projectstatusname}，无需支付!`)
        //   return
        // }
        this.$router.push({name: 'psuBzjPayForm', params: {form: this.psu, type: 1}})
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delProject () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xmgl/project/delPsu',
            method: "post",
            data: this.psu
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async cellClick (row) {
        this.psu = row.row
        this.project = row.row
        console.log('this.psu',this.psu);
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.cosid = this.$store.getters.loginUser.cosid
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPsuListByComId',
          params: this.query
        })
        res.list.forEach(e => {
          e.psutypeCN = +e.psutype === 1 ? '公开':'邀请'
          if(+e.psutype===2){
            if(+e.psustatus === 1){
              e.psustatusname = '待接受'
            } else if(+e.psustatus === 3){
              e.psustatusname = '己接受'
            } else if(+e.psustatus === 4){
              e.psustatusname = '己拒绝'
            }
          }
          if(Number(e.psubmamt) > 0){
            let bmpayment = '(未付)'
            if(+e.psubmpaytype > 0 && +e.psubmpayflg !== 2){
              bmpayment='(待确认)'
            }
            if(+e.psubmpayflg === 1){
              bmpayment='(已付)'
            } 
            e.psubmamt = utils.comdify(e.psubmamt) + bmpayment
          }
          if(Number(e.psubmamt) == 0){
            e.psubmamt = '免费'
          }
          if(Number(e.psubzjamt) > 0){
              let bzjpayment = '(未付)'
            if (+e.psubzjpaytype > 0 && +e.psubzjpayflg !== 2) {
                bzjpayment = '(待确认)'
            } 
            if(+e.psubzjpayflg === 1){
              bzjpayment = '(已付)'
            }
            if(+e.psubzjreturnflg === 1) {
              bzjpayment = '(已退)'
            }
            e.psubzjamt = utils.comdify(e.psubzjamt) + bzjpayment
          }
          if(Number(e.psubzjamt) === 0){
            e.psubzjamt = '免费'
          }
        });
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      },
      subZeroAndDot(s){
        if(s){
          s = s.toString()
          if(s.indexOf(".") > 0){
            s = s.replace(/0+?$/, "");//去掉多余的0
            s = s.replace(/[.]$/, "");//如最后一位是.则去掉
          }
        }
        return s;
      },
      bmxx(row) {
        if (!row) {
          if (!this.psu.psuid) {
            this.$message.warning('请选择一个项目!')
            return
          }
        }
        if(this.project.psustatusname == '审核通过'){
          this.$message.warning('审核已通过')
          return
        }
        let flg = 1;
        this.$router.push({name: 'psuBmForm', params: {form: this.project, type: flg}})
      },
      async showdownFild(row){
        let pjname = +row.prsflg === 1 ? '竞价':'招标'
        let pjtype = row.projectacomid === ''?'采购人':'代理人'
        if(+row.psutype === 2 && row.psuuserid === null){
          this.$message.warning('请先接受邀请！')
          return
        }
        if(+row.psutype === 2 && +row.psustatus === 4){
          this.$message.warning('您拒绝了邀请，不能查看文件')
          return
        }
        // if(+row.prsbmneedconfirm === 1){
        //     if(+row.psustatus === 1){
        //         this.$message.warning(`请联系${pjtype}业务员审批报名`)
        //         return
        //     }
        //     if(+row.psustatus === 4){
        //           this.$message.warning(`你已经被${pjtype}拒绝`)
        //         return
        //     }
        //     if(+row.psustatus === 2){
        //           this.$message.warning(`你已经被${pjtype}驳回`)
        //         return
        //     }
        // }
        // if(+row.projectbmamt > 0){
        //     if(+row.psustatus === 3 && +row.psubmpaytype === 0){
        //         this.$message.warning(`请缴纳报名费后下载${pjname}附件`)
        //         return
        //     }
        //     if(+row.psustatus === 3 && +row.psubmpaytype !== 0 && +row.psubmpayflg === 2){
        //         this.$message.warning(`请重新缴纳报名费`)
        //         return
        //     }
        //     if(+row.psustatus === 3 && +row.psubmpaytype !== 0 && +row.psubmpayflg === 0){
        //         this.$message.warning(`请联系${pjtype}财务及时确认报名费`)
        //         return
        //     }
        // }
        // if(+row.projectbzjamt > 0){
        //     if(+row.psustatus === 3 && +row.psubzjpaytype === 0){
        //         this.$message.warning(`请缴纳保证金后下载${pjname}附件`)
        //         return
        //     }
        //     if(+row.psustatus === 3 && +row.psubzjpaytype !== 0 && +row.psubzjpayflg === 2){
        //         this.$message.warning(`请重新缴纳保证金`)
        //         return
        //     }
        //     if(+row.psustatus === 3 && +row.psubzjpaytype !== 0 && +row.psubzjpayflg === 0){
        //         this.$message.warning(`请联系${pjtype}财务及时确认保证金`)
        //         return
        //     }
        // }
        this.dialogVisible = true
        this.appendList = await request({
          method: 'get',
          url: '/ywgl/append/getAppendListByFromId',
          params: {appendfromid: row.projectid, appendfromtype: 11}
        })
      },
    },
    filters: {
    }
  }
</script>
<style lang="scss" scoped>
// @import "../../styles/filelist";
.fileitem{
  border-bottom:1px solid #ccc;
  border-left:1px solid #ccc;
  border-right:1px solid #ccc;
  padding: 5px 10px;
  .name{
    a{
        color: #2f74ff;
        cursor: pointer;
    }
  }
}
.fileitem:nth-child(1){
  border-top: 1px solid #ccc;
}
</style>
